module.exports = __webpack_public_path__ + "img/equipment-icon-sp.f2a2c3e3.png";